import { render, staticRenderFns } from "./Custom.vue?vue&type=template&id=5f3f0c14&"
var script = {}
import style0 from "./Custom.vue?vue&type=style&index=0&id=5f3f0c14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports